import React, { createContext, useContext } from 'react';
import { blogArticles, type BlogArticle } from '../data/blogArticles';
interface BlogContextType {
  articles: BlogArticle[];
}
const BlogContext = createContext<BlogContextType | undefined>(undefined);
export const BlogContextProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <BlogContext.Provider value={{
    articles: blogArticles
  }} data-id="element-927" data-mp="3t9d3fvpy5bkn">
      {children}
    </BlogContext.Provider>;
};
export const useBlogContext = () => {
  const context = useContext(BlogContext);
  if (!context) {
    throw new Error('useBlogContext debe usarse dentro de un BlogContextProvider');
  }
  return context;
};